import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { router } from "./router";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/plan.css";
import "./styles/m3.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

if ("serviceWorker" in navigator) {
  if (import.meta.env.PROD) {
    // Register the service worker only in production builds (dev uses HMR).
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    // In dev, tear down any service worker left over from a prior prod build —
    // otherwise its cached app shell serves a stale bundle and the dev server's
    // changes never appear. Navigations are network-first, so this new code runs
    // on load and can self-heal a browser that has a stale SW registered.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) reg.unregister();
    });
    if (window.caches) {
      caches.keys().then((keys) => {
        for (const k of keys) caches.delete(k);
      });
    }
  }
}

const el = document.getElementById("app");
if (!el) throw new Error("#app root element not found");

createRoot(el).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
